import React from "react"
import { Link as RouterLink } from "react-router-dom";
import styles from "./link.scss"

export const Link = ({ children, ...props }) => {

  return props.to ? (
    <RouterLink
      {...props}
      to={props.to}
      className={`${styles.link} ${props.className || ""}`}
    >
      {children}
    </RouterLink>
  ) : (
    <a
      {...props}
      className={`${styles.link} ${props.className || ""}`}
    >
      {children}
    </a>
  )
}



// WEBPACK FOOTER //
// ./src/components/Link/Link.tsx